import { SecondaryScreenLayout } from "../interfaces/secondaryScreens";

const DefaultPlayersColumnsPerLayoutColumn = 1;
const DefaultPlayersRowsPerLayoutColumn = 3;
const DefaultPlayersPerLayoutColumn = DefaultPlayersColumnsPerLayoutColumn * DefaultPlayersRowsPerLayoutColumn;

const DefaultLayout: SecondaryScreenLayout = {
  id: undefined,
  justifyContent: "center",
  topBar: {
    brand: true,
    user: true,
    watchers: true,
  },
  columns: [
    {
      width: 3,
      contentType: "players",
    },
    {
      width: 1,
      contentType: "chat",
    },
  ],
};

export const ScreenConstants = {
  DefaultPlayersColumnsPerLayoutColumn,
  DefaultPlayersRowsPerLayoutColumn,
  DefaultPlayersPerLayoutColumn,
  DefaultLayout,
};